export default "__VITE_ASSET__BoG6hsVD__"